/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { Link } from "react-router-dom";
import Group580 from "../Group580";
import "./Web1920136.css";

function Web1920136(props) {
  const {
    x38451843462_E970E5F167_K,
    group583,
    flyThrough,
    learnMore,
    travelAgainInMilkyWay,
    overlapGroup5,
    viewFullscreenImage,
    polygon3,
    name,
    thisDramaticImage,
    travelToOtherGalaxies,
    group580Props,
  } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-136 screen">
        <div className="overlap-group7-8">
          <img className="x38451843462_e970e5f167_k" src={x38451843462_E970E5F167_K} />
          <div className="rectangle-2-36 border-1px-dove-gray"></div>
          <Link to="/web-1920-10">
            <div className="group-583-28" style={{ backgroundImage: `url(${group583})` }}></div>
          </Link>
          <Group580
            path691={group580Props.path691}
            path692={group580Props.path692}
            className={group580Props.className}
          />
          <Link to="/web-1920-139">
            <div className="group-142-12">
              <div className="overlap-group-44">
                <div className="rectangle-33-19 border-3px-sulu"></div>
                <div className="fly-through lato-medium-white-18px">{flyThrough}</div>
              </div>
            </div>
          </Link>
          <div className="overlap-group3-11">
            <div className="rectangle-33-19 border-3px-picton-blue"></div> 
            <div className="learn-more-10 lato-medium-white-18px">{learnMore}</div>
          </div>
          <Link to="/explore-our-milky-way">
            <div className="group-284-10">
              <div className="overlap-group-44">
                <div className="rectangle-33-19 border-3px-sulu"></div>
                <div className="travel-again-in-milky-way-1 lato-medium-white-18px">{travelAgainInMilkyWay}</div>
              </div>
            </div>
          </Link>
          <div className="overlap-group5-4" style={{ backgroundImage: `url(${overlapGroup5})` }}>
            <div className="view-fullscreen-image-10 lato-medium-white-14px">{viewFullscreenImage}</div>
            <img className="polygon-3-10" src={polygon3} />
          </div>
          <div className="name lato-bold-white-30px">{name}</div>
          <div className="this-dramatic-image lato-medium-white-26px">{thisDramaticImage}</div>
          <Link to="/i-want-to-see-a-different-galaxy">
            <div className="group-485-10">
              <div className="overlap-group-44">
                <div className="rectangle-33-19 border-3px-feijoa"></div>
                <div className="travel-to-other-galaxies-1 lato-medium-white-17px">{travelToOtherGalaxies}</div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Web1920136;
